import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';

import { changeOgMeta } from 'data/index';

Vue.use(Router);

const SITE_NAME = 'Очень Интересно';

const HOST_NAME = process.env.APP_URL;

export const JOB = 'JOB';
export const HOME = 'HOME';
export const PROJECTS = 'projects';
export const PROJECT = 'PROJECT';
export const JOINTOTEAM = 'JOINTOTEAM';
export const TEAM = 'team';
export const CAMP = 'CAMP';
export const PAGENOTFOUND = 'PAGENOTFOUND';
export const PROMO = 'PROMO';

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      component: () =>
        import(/* webpackChunkName: "page-not-found" */ '../views/PageNotFound.vue'),
      name: PAGENOTFOUND,
      meta: {
        title: '404 - Страница не найдена',
      },
    },
    {
      path: '/',
      component: () =>
        import(/* webpackChunkName: "home-page" */ '../views/Home.vue'),
      name: HOME,
      meta: {
        title: SITE_NAME,
      },
    },
    {
      path: '/camp',
      component: () =>
        import(/* webpackChunkName: "camp-page" */ '../views/Camp.vue'),
      name: CAMP,
      meta: {
        title: `${SITE_NAME} - Summer camp`,
        menuName: 'Summer camp',
      },
    },
    {
      path: '/dump',
      redirect: '/camp',
    },
    {
      path: '/promo',
      redirect: '/camp',
    },
    {
      path: '/projects',
      component: () =>
        import(/* webpackChunkName: "projects-page" */ '../views/Projects.vue'),
      name: PROJECTS,
      meta: {
        menuName: 'Проекты',
        title: `${SITE_NAME} - Наши проекты`,
      },
    },
    {
      path: '/projects/:slug',
      component: () =>
        import(/* webpackChunkName: "project-page" */ '../views/Project.vue'),
      name: PROJECT,
      props: true,
      meta: {
        title: `${SITE_NAME} - Наши проекты`,
      },
    },
    {
      path: '/join',
      component: () =>
        import(/* webpackChunkName: "joint-to-team-page" */ '../views/JoinToTeam.vue'),
      name: JOINTOTEAM,
      meta: {
        menuName: 'Присоединяйся к нам',
        title: `${SITE_NAME} - Присоединяйся`,
      },
    },
    {
      path: '/join-to-team',
      redirect: '/join',
    },
    {
      path: '/job',
      component: () =>
        import(/* webpackChunkName: "job-page" */ '../views/Job.vue'),
      name: JOB,
      meta: {
        title: `${SITE_NAME} - Вакансия`,
      },
    },
    {
      path: '/team',
      component: () =>
        import(/* webpackChunkName: "team-page" */ '../views/Team.vue'),
      name: TEAM,
      meta: {
        title: `${SITE_NAME} - Наша команда`,
        menuName: 'Команда',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path.search('//') !== -1) {
    next(to.path.replace('//', '/'));
  } else {
    if (HOST_NAME !== 'undefined') {
      changeOgMeta('og:url', HOST_NAME + to.path);
      changeOgMeta('og:image', `${HOST_NAME}/static/page-preview/main.png`);
    }
    document.title = to.meta.title || SITE_NAME;
    next();
  }
});

/**
 * Finish page loader on complete of route resolving.
 */
router.afterEach(() => {
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js